module.exports = __webpack_public_path__ + "img/provider2.023912be.png";